var PresentationsToolbarView, PresentationsView, PresentationsWithToolbarView, View, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

View = require('base/views/view');

PresentationsView = require('views/evidence_syntheses/presentations_view');

PresentationsToolbarView = require('views/presentations_toolbar_view');

mediator = require('mediator');

module.exports = PresentationsWithToolbarView = (function(_super) {
  __extends(PresentationsWithToolbarView, _super);

  function PresentationsWithToolbarView() {
    return PresentationsWithToolbarView.__super__.constructor.apply(this, arguments);
  }

  PresentationsWithToolbarView.prototype.id = 'presentations';

  PresentationsWithToolbarView.prototype.initialize = function() {
    PresentationsWithToolbarView.__super__.initialize.apply(this, arguments);
    this.subview("PresentationsView", new PresentationsView({
      model: this.model
    }));
    return this.subview('toolbar', new PresentationsToolbarView({
      model: this.model,
      submodule: 'presentations'
    }));
  };

  return PresentationsWithToolbarView;

})(View);
